import { useSelector, useDispatch } from "react-redux";
import { RoHSAction } from "../../../../store/RoHS/RoHS-slice";
import { useState } from "react";

import { Box, Button, Modal, Stack, Typography, Tooltip } from "@mui/material";
import ColoredTextField from "../../../UI/ColoredTextField";
import UserOrgDropdown from "../../../UI/UserOrgDropdown";

import { OSAltKey } from "../../../Util/Util";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	minWidth: { xs: 420, sm: 420, md: 500, lg: 650, xl: 800 },
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
};

const EditMpnNote = (props) => {
	const dispatch = useDispatch();

	const userNTID = useSelector((state) => state.authenticationState.userNTID);

	const open = useSelector((state) => state.rohsStates.showMpnNotePopUp);
	const itemPartNumber = useSelector((state) => state.rohsStates.partInfo.partNumber);
	const selectedMpn = useSelector((state) => state.rohsStates.selectedMpn);
	const selectedMfgId = useSelector((state) => state.rohsStates.selectedMfgId);
	const selectedMfgName = useSelector((state) => state.rohsStates.selectedMfgName);
	const editedMpnNote = useSelector((state) => state.rohsStates.editedMpnNote);
	const editingMpnNoteOrg = useSelector((state) => state.rohsStates.editingMpnNoteOrg);

	const [noteEdited, setNoteEdited] = useState(false);
	const [error, setError] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showErrorMessage, setShowErrorMessage] = useState(false);

	const saveNoteHandler = () => {
		const MpnNoteJSON = {
			item: itemPartNumber,
			userid: userNTID,
			userorg: editingMpnNoteOrg,
			mfg_pn: selectedMpn,
			mfgid: selectedMfgId,
			mfg_name: selectedMfgName,
			note: editedMpnNote.note,
		};
		if (noteEdited && editedMpnNote.note?.trim() !== "") {
			const mpnInfo = `${selectedMfgName}: ${selectedMpn}`;
			props.updateMpnNote(MpnNoteJSON, mpnInfo);
			setNoteEdited(false);
		} else if (editedMpnNote.note?.trim() === "") {
			setBlankError();
		} else {
			setErrorMessage("No changes detected, cancelling save");
			setShowErrorMessage(true);
			console.log(errorMessage);
			setTimeout(() => {
				dispatch(RoHSAction.setEditingMpnNote(false));
				setShowErrorMessage(false);
				setErrorMessage("");
			}, 1000);
		}
	};

	const handleEditNote = (event) => {
		if (!noteEdited) setNoteEdited(true);
		dispatch(RoHSAction.handleEditMpnNote(event.target.value));
		if (event.target.value?.trim() === "") {
			setBlankError();
		} else if (error) setError(false);
	};

	const setBlankError = () => {
		setErrorMessage("Note cannot be blank");
		setError(true);
	};

	const cancelEditNoteHandler = () => {
		dispatch(RoHSAction.cancelUpdateMpnNote());
		dispatch(RoHSAction.setEditingMpnNote(false));
		setNoteEdited(false);
		setError(false);
	};

	const handleOrgSelected = (value) => {
		dispatch(RoHSAction.setEditingMpnNoteOrg(value));
	};

	const handleOnKeyDown = (e) => {
		if (e.code === "KeyS" && e.altKey === true && !error) {
			e.preventDefault();
			saveNoteHandler();
		} else if (e.code === "KeyC" && e.altKey === true) {
			e.preventDefault();
			cancelEditNoteHandler();
		}
	};

	return (
		<Box>
			<Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" disableScrollLock>
				<Box
					sx={style}
					onKeyDown={(e) => {
						handleOnKeyDown(e);
					}}
				>
					{showErrorMessage ? (
						<Typography fontSize={20}>{errorMessage}</Typography>
					) : (
						<>
							<Stack mb={2} spacing={1}>
								<Typography fontSize={14} mr={2}>
									Note associated with <i style={{ color: "rgb(0,0,128)" }}>{selectedMfgName}</i>:{" "}
									<i style={{ color: "rgb(0,0,128)" }}>{selectedMpn}</i>
								</Typography>
								<UserOrgDropdown label={"Select Org"} selectedOrg={editingMpnNoteOrg} handleOrgSelected={handleOrgSelected} />
								<ColoredTextField
									fullWidth
									autoFocus
									minRows={3}
									maxRows={3}
									multiline
									focused
									onChange={handleEditNote}
									value={editedMpnNote.note}
									error={error}
									helperText={error && errorMessage}
								/>
							</Stack>

							<Box>
								<Tooltip title={`For shortcut press ${OSAltKey} + S`}>
									<span>
										<Button disabled={error} onClick={saveNoteHandler}>
											<u style={{ textDecorationThickness: "2.5px", fontWeight: "bold" }}>S</u>ave
										</Button>
									</span>
								</Tooltip>
								<Tooltip title={`For shortcut press ${OSAltKey} + C`}>
									<Button onClick={cancelEditNoteHandler}>
										<u style={{ textDecorationThickness: "2.5px", fontWeight: "bold" }}>C</u>ancel
									</Button>
								</Tooltip>
							</Box>
							<Typography sx={{ fontSize: "0.7rem" }}>{`Shortcut: ${OSAltKey} + Hotkey`}</Typography>
						</>
					)}
				</Box>
			</Modal>
		</Box>
	);
};

export default EditMpnNote;
